import Navbar from "../components/Navbar";
import { FaAngleDoubleDown } from "react-icons/fa";
import { Helmet } from 'react-helmet-async';
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../utils/auth";
import EpisodeList from "../layouts/EpisodeLayout";

const SeasonOneEpisodes = () => {
    const { user, loading } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!loading) {
            if (!user) {
                navigate("/login");
            } else if (user.plan_status !== "ACTIVE") {
                navigate("/membership-plan");
            }
        }
    }, [user, loading, navigate]);

    return (
        <>
            <Helmet>
                <title>Season One - Art India Education</title>
            </Helmet>
            <main>
                <Navbar />
                {/* Top Half-Screen Banner Section */}
                <section className="relative h-screen w-full overflow-hidden font-['EB_Garamond','Nunito','sans-serif']">
                    <div className="relative w-full h-full overflow-hidden">
                        {/* 🔳 Overlay */}
                        <div className="absolute inset-0 bg-black/50 z-10"></div>

                        {/* 🖼️ Image */}
                        <img
                            src="Season-1-ep-banner.jpg"
                            alt={`banner`}
                            className="absolute top-[-25%] h-[150%] w-full object-cover z-0"
                        />

                        {/* 📄 Text Wrapper */}
                        <div className="absolute inset-0 z-20 flex flex-col justify-center items-center text-white text-center px-4">
                            <h1 className="text-4xl font-extrabold mb-6">SEASON ONE</h1>
                            <p className="text-2xl font-medium max-w-5xl font-['EB_Garamond','Nunito','sans-serif']">
                                India’s Greatest Art Collective or Is It? – The Progressive Artists’ Group (PAG) and its Contexts
                            </p>
                        </div>
                    </div>
                    {/* ⬇️ Double Down Arrow */}
                    <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 z-30 text-white animate-bounce">
                        <FaAngleDoubleDown size={32} />
                    </div>
                </section>

                <div className="flex justify-center items-center px-6 pt-10">
                    <p className="text-lg text-justify font-medium max-w-2xl font-['EB_Garamond','Nunito','sans-serif']">
                        This season, we return to the 19th century and decode the rise of Modern Indian Art.
                        We will engage in close readings of art collectives of the time with a focus on the
                        key artists and artworks that emerged from the Progressive Artists’ Group (PAG).
                        What, according to you, is the lasting legacy of the Progressive Artists’ Group or PAG?
                        As you watch this season, we hope you will have an answer to this burning question.
                    </p>
                </div>
                <section className="p-20">
                    <EpisodeList
                        seasonTitle="SEASON ONE"
                        seasonName="season-one-episodes"
                        episodes={[
                            {
                                id: "AIE-SE01EP01",
                                title: "Episode One",
                                subtitle: "A Window into the Modern: Unpacking the PAG",
                                details:
                                    "In our pilot episode, immerse yourself in a masterclass with Abhay Sardesai, Editor of Art India Magazine as he takes you on a journey with Bombay’s Progressive Artists’ Group (PAG). Join in as he acquaints you with the dynamic landscape of the time that gave rise to the new school of Modern Indian art.",
                                videoUrl:
                                    "https://player.vimeo.com/video/676175858?title=0&byline=0&portrait=0&autoplay=1&app_id=122963",
                                thumbnail: "/AIE-SE01EP01-thumbnail.jpg",
                            },
                        ]}
                    />
                    <EpisodeList
                        seasonTitle="SEASON ONE"
                        seasonName="season-one-episodes"
                        episodes={[    
                            {
                                id: "AIE-SE01EP02",
                                title: "Episode Two",
                                subtitle:
                                    "The Still And Quivering Centre: Close Reading Of S. H. Raza With Yashodhara Dalmia And Abhay Sardesai",
                                details:
                                    "Tune in to a conversation with eminent art historian, Yashodhara Dalmia and the editor of Art India Magazine, Abhay Sardesai as they navigate the life and times of master artist and eminent member of the Progressive Artists Group – Sayed Haider Raza. Traverse through his iconic life and works in this episode and get to know a doyen of Modern Indian Art. Born in India, he lived and worked in France from 1950 until his death. Although, his intimate bond with India shines through the rich use of color in his work coupled with his passion for Indian philosophy and cosmology which continues to place his work as some of the most coveted in the world today.",
                                videoUrl:
                                    "https://player.vimeo.com/video/682850108?title=0&byline=0&portrait=0&autoplay=1&app_id=122963",
                                thumbnail: "/AIE-SE01EP02-thumbnail.jpg",
                            },
                        ]}                       
                    />
                    <EpisodeList
                        seasonTitle="SEASON ONE"
                        seasonName="season-one-episodes"
                        episodes={[    
                            {
                                id: "AIE-SE01EP03",
                                title: "Episode Three",
                                subtitle:
                                    "Many Faces Of The Modern: The PAG, The Lahore Circle And Other Collectives",
                                details:
                                    "Art India Education brings to you its much awaited third episode entitled ‘Many Faces of the Modern: The PAG, The Lahore Circle and Other Collectives’. In this episode, join Zehra Jumabhoy, UK based acclaimed art historian, writer and curator as she takes you through the process of curating an integrated Modern Art exhibition. Explore the context of modern south asian diasporic art collectives like the Lahore Circle, the PAG and more through an illuminating conversation between Zehra Jumabhoy and Abhay Sardesai.",
                                videoUrl:
                                    "https://player.vimeo.com/video/682850108?title=0&byline=0&portrait=0&autoplay=1&app_id=122963",
                                thumbnail: "/AIE-SE01EP03-thumbnail.jpg",
                            },
                        ]}
                    />
                    <EpisodeList
                        seasonTitle="SEASON ONE"
                        seasonName="season-one-episodes"
                        episodes={[    
                            {
                                id: "AIE-SE01EP04",
                                title: "Episode Four",
                                subtitle:
                                    "The Progressives In The Marketplace: Conversation Between Dadiba Pundole And Tasneem Mehta",
                                details:
                                    "Explore the ever-changing art world and its relationship with the art market in the Season 1 Finale of Art India Education! Join experts Tasneem Zakaria Mehta and Dadiba Pundole as they delve into the impact of the Progressives on the art market, the rapidly growing collector base, and the skyrocketing prices of artworks. With exclusive insights on the record-breaking auction of V. S. Gaitonde’s artwork, and much more, our final episode is a captivating discussion, taking you beyond art and art practices to understand the art world through unique perspectives.",
                                videoUrl:
                                    "https://player.vimeo.com/video/709038515?title=0&byline=0&portrait=0&autoplay=1&app_id=122963",
                                thumbnail: "/AIE-SE01EP04-thumbnail.jpg",
                            },
                        ]}
                    />
                </section>

            </main>
        </>
    );
};
export default SeasonOneEpisodes;